import { render, staticRenderFns } from "./modal-editor-profile.vue?vue&type=template&id=459e83b7&"
import script from "./modal-editor-profile.vue?vue&type=script&lang=js&"
export * from "./modal-editor-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports